"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconFlagEs = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const IconFlagEs = (_a) => {
    var { title, titleId } = _a, props = __rest(_a, ["title", "titleId"]);
    return ((0, jsx_runtime_1.jsxs)("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", "aria-labelledby": titleId }, props, { children: [title ? (0, jsx_runtime_1.jsx)("title", { id: titleId, children: title }) : null, (0, jsx_runtime_1.jsxs)("g", { fill: "none", fillRule: "evenodd", children: [(0, jsx_runtime_1.jsx)("path", { fill: "#FFF423", d: "M2 15.396h20V8.593H2z" }), (0, jsx_runtime_1.jsx)("path", { fill: "#E91C35", d: "M2 17.996c0 .55.45 1 1 1h18c.55 0 1-.45 1-1v-2.602H2zM21 5H3c-.55 0-1 .45-1 1v2.599h20V6c0-.55-.45-1-1-1" })] })] })));
};
exports.IconFlagEs = IconFlagEs;
exports.IconFlagEs.defaultProps = {
    height: '30px',
    width: '30px',
};
exports.default = exports.IconFlagEs;
